import React, { useState } from "react";
import TagsInput from "react-tagsinput";
import isEqual from "lodash/isEqual";
import { setAdminKeywords } from "../../firestore/firestoreService";
import { closeModal } from "../modals/modalReducer";
import { asyncActionError } from "../../async/asyncReducer";
import { useDispatch } from "react-redux";
import { Button } from "semantic-ui-react";

export default function MyKeywordTagInput({ job, adminKeywords = [] }) {
  const dispatch = useDispatch();

  const [keywordTags, setKeywordTags] = useState(adminKeywords);
  const [isUpdating, setIsUpdating] = useState(false);

  function handleChange(tags) {
    const downCaseTags = tags.map((item) => item.toLowerCase());
    setKeywordTags(downCaseTags);
  }

  async function handleSaveKeywords() {
    try {
      setIsUpdating(true);
      await setAdminKeywords(job, keywordTags);
      dispatch(closeModal());
    } catch (e) {
      dispatch(asyncActionError(e));
    } finally {
      setIsUpdating(false);
    }
  }

  return (
    <div>
      <TagsInput
        value={keywordTags}
        onChange={handleChange}
        inputProps={{
          className: "react-tagsinput-input",
          placeholder: "Add a keyword",
        }}
        addOnBlur={true}
        removeKeys={[]}
      />
      <Button
        className="overwrite-button cta-orange block-button"
        content={"Save keywords"}
        onClick={handleSaveKeywords}
        loading={isUpdating}
        disabled={isEqual(adminKeywords, keywordTags)}
        style={{ margin: "15px 0 0 2px" }}
        type={"button"}
      />
    </div>
  );
}
